import ReportProductCard from "./ReportProductCard";

export default ReportProductCard;
